/**
 * @generated SignedSource<<5746415830ff684f42c0bef541d4cdb2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CloudStorageProvider = "GOOGLE_DRIVE" | "ONEDRIVE" | "%future added value";
export type ConnectCloudStorageInput = {
  provider: CloudStorageProvider;
  code: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type cloudProviderQueriesConnectMutation$variables = {
  input: ConnectCloudStorageInput;
};
export type cloudProviderQueriesConnectMutation$data = {
  readonly connectCloudStorage: {
    readonly provider: CloudStorageProvider | null;
    readonly accountEmail: string | null;
    readonly status: string | null;
  } | null;
};
export type cloudProviderQueriesConnectMutation = {
  variables: cloudProviderQueriesConnectMutation$variables;
  response: cloudProviderQueriesConnectMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConnectCloudStoragePayload",
    "kind": "LinkedField",
    "name": "connectCloudStorage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accountEmail",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cloudProviderQueriesConnectMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cloudProviderQueriesConnectMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8783b433d0d00bbb9acbc371a06e7188",
    "id": null,
    "metadata": {},
    "name": "cloudProviderQueriesConnectMutation",
    "operationKind": "mutation",
    "text": "mutation cloudProviderQueriesConnectMutation(\n  $input: ConnectCloudStorageInput!\n) {\n  connectCloudStorage(input: $input) {\n    provider\n    accountEmail\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "5f3473f1f95a95514d0bda5cdf5a593b";

export default node;
